import { render, staticRenderFns } from "./stakeInput2.vue?vue&type=template&id=6a080620&lang=pug&"
import script from "./stakeInput2.vue?vue&type=script&lang=js&"
export * from "./stakeInput2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports